<template>
  <div class="content-wrapper">
    <div class="content-body">
      <article class="body-article" >
        <!-- 아코디언 : accordion / 닫힘 : close -->
        <section
            :class="[
            'article-section',
            'section-01',
            'accordion',
            { close: !isSearchSectionVisible },
          ]"
        >
          <div class="section-header">
            <div class="header-left">
              <div class="header-title" @click="handleSearchSectionHeaderClick">
                회원 조건 검색
              </div>
            </div>
            <div class="header-right">
              <ul class="header-button">
                <li class="lookup keyColor">
                  <erp-button
                      button-div="GET"
                      :is-shortcut-button="true"
                      :disabled="isLoading"
                      @click.native="onSearchClick"
                  >
                    조회
                  </erp-button>
                </li>
                <li class="reset">
                  <erp-button
                      button-div="GET"
                      :is-icon-custom="true"
                      @click.native="searchInit"
                  > 초기화
                  </erp-button>
                </li>
                <li class="print">
                  <erp-button
                      button-div="FILE"
                      :disabled="isCouponCheckinExcelDownloading"
                      @click.native="onExcelButtonClicked"
                  >
                    Excel
                  </erp-button>
                </li>
              </ul>
            </div>
          </div>
          <div
              class="section-body"
              style="display: flex; flex-direction: column"
          >
            <div style="flex: 1; overflow: auto">
              <article class="body-article" style="padding: 0">
                <section class="article-section" style="padding: 0">
                  <div class="section-body" style="padding: 18px; border: none">
                    <div class="body-data outerData">
                      <div class="data-outer">
                        <div class="data-inner">
                          <ul class="data-content">
                            <li class="field" style="width: calc(100% + 1px)">
                              <!-- 필수 : required -->
                              <div class="title outerDataTitle">
                                <div class="outerDataTitleItem">
                                  {{ vueCouponSearchNameObj.visitInfo.title }}
                                </div>
                              </div>
                              <div class="content">
                                <div
                                    class="body-data innerData"
                                    style="margin: -1px"
                                >
                                  <div class="data-outer">
                                    <div class="data-inner">
                                      <ul class="data-content">
                                        <li class="field" >
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{ vueCouponSearchNameObj.visitInfo.memberDiv.title }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <check-box-row
                                                    v-model=" couponSearchOption.visitInfo.memberDiv"
                                                    :code=" vueCouponSearchNameObj.visitInfo.memberDiv .code"
                                                ></check-box-row>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>

                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{ vueCouponSearchNameObj.visitInfo.sexCode.title }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <check-box-row
                                                    v-model=" couponSearchOption.visitInfo.sexCode"
                                                    :code=" vueCouponSearchNameObj.visitInfo.sexCode.code"
                                                    :selectAll="false"
                                                ></check-box-row>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>

                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj
                                                  .visitInfo.ageCodes.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <check-box-row
                                                    v-model="
                                                    couponSearchOption
                                                      .visitInfo.ageCodes
                                                  "
                                                    :code="
                                                    vueCouponSearchNameObj
                                                      .visitInfo.ageCodes
                                                      .code
                                                  "
                                                />
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj
                                                  .visitInfo.hp4.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <div class="form">
                                                  <input-text
                                                      v-model="
                                                      couponSearchOption
                                                        .visitInfo.hp4
                                                    "
                                                      maxlength="4"
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div
                                              :class="[
                                              'title',

                                            ]"
                                          >
                                            {{
                                              vueCouponSearchNameObj.visitInfo
                                                  .visitDate.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <div class="form">
                                                  <input-date-range
                                                      v-model="
                                                      couponSearchOption
                                                        .visitInfo.visitDate
                                                    "
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj.visitInfo
                                                  .visitTime.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li
                                                  class="item form-group"
                                                  style="width: calc((100% - 21px) / 2);border-right: none;"
                                              >
                                                <div class="form">
                                                  <input-time
                                                      v-model="
                                                      couponSearchOption
                                                        .visitInfo
                                                        .visitStartTime
                                                    "
                                                      :format="'HH:mm'"
                                                      @change="
                                                      onChangeVisitTime
                                                    "
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                  class="item form-group"
                                                  style="width: 21px;border-right: none;"
                                              >
                                                ~
                                              </li>
                                              <li
                                                  class="item form-group"
                                                  style="width: calc((100% - 21px) / 2);"
                                              >
                                                <div class="form">
                                                  <input-time
                                                      v-model="
                                                      couponSearchOption
                                                        .visitInfo
                                                        .visitEndTime
                                                    "
                                                      :format="'HH:mm'"
                                                      @change="
                                                      onChangeVisitTime
                                                    "
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj.visitInfo
                                                  .bsnCode.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <check-box-row
                                                    v-model="
                                                    couponSearchOption
                                                      .visitInfo.bsnCode
                                                  "
                                                    :code="
                                                    vueCouponSearchNameObj
                                                      .visitInfo.bsnCode.code
                                                  "
                                                    :except-code="['CLOSE']"
                                                    :selectAll="false"
                                                ></check-box-row>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li
                                            class="field"
                                            style="width: calc(((100% / 3) * 2) + 1px);"
                                        >
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj.visitInfo
                                                  .dwCode.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li class="item form-group">
                                                <check-box-row
                                                    v-model="
                                                    couponSearchOption
                                                      .visitInfo.dwCode
                                                  "
                                                    :code="
                                                    vueCouponSearchNameObj
                                                      .visitInfo.dwCode.code
                                                  "
                                                    :textColor="true"
                                                ></check-box-row>
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                        <li class="field">
                                          <!-- 필수 : required -->
                                          <div class="title">
                                            {{
                                              vueCouponSearchNameObj.visitInfo
                                                  .visitCnt.title
                                            }}
                                          </div>
                                          <div class="content">
                                            <ul class="row">
                                              <li
                                                  class="item form-group"
                                                  style="width: 50%"
                                              >
                                                <div class="form">
                                                  <input-number
                                                      v-model="
                                                      couponSearchOption
                                                        .visitInfo.visitCnt
                                                    "
                                                      :allowDot="false"
                                                      :allowMinus="false"
                                                      :max="4200000000"
                                                      :propMaxLength="10"
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                  class="item form-group"
                                                  style="width: 50%"
                                              >
                                                회 이상
                                              </li>
                                            </ul>
                                          </div>
                                        </li>
                                      </ul>
                                      <div class="border-left"></div>
                                      <div class="border-right"></div>
                                      <div class="border-bottom"></div>
                                    </div>
                                  </div>
                                  <div class="border-left"></div>
                                  <div class="border-right"></div>
                                  <div class="border-bottom"></div>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <div class="border-left"></div>
                          <div class="border-right"></div>
                          <div class="border-top"></div>
                          <div class="border-bottom"></div>
                        </div>
                      </div>
                      <div class="border-left"></div>
                      <div class="border-right"></div>
                      <div class="border-top"></div>
                      <div class="border-bottom"></div>
                    </div>
                    <erp-button
                        button-div="CLOSE"
                        ref="submitBtn"
                        v-show="false"
                        type="submit"
                    ></erp-button>
                  </div>
                </section>
              </article>
            </div>
            <div style="border-top: 1px solid #ccc;display: flex;flex-direction: row;">
              <div style="box-sizing: border-box;float: left;line-height: 19px;width: 82px;min-height: 27px;padding: 5px 5px 3px 5px;border-right: 1px solid #e0e0e0;display: flex;">
                <div style="width: 100%; text-align: center">검색조건</div>
              </div>
              <div style="box-sizing: border-box;float: left;line-height: 19px;width: calc(100% - 82px);min-height: 27px;padding: 5px 5px 3px 5px;flex: 1;">
                <div v-for="(selectedData, i) in selectedData" :key="selectedData.name" style="float: left; padding: 0 4px">
                  <div style="float: left" v-if=" i < (isSearchSectionVisible  ? 3 : 100)">
                    {{ selectedData.name }} : {{ selectedData.data }}
                  </div>
                  <erp-button
                      button-div="DELETE"
                      style="float: left;cursor: pointer;border: none;background: none;margin: 0;padding: 3px 6px 5px 6px;outline: none;"
                      :use-syncfusion-component-style="false"
                      @click="
                      deleteSelectedData(
                        selectedData.key,
                        selectedData.innerKey
                      )
                    "
                  >
                    <div class="iconClose"></div>
                  </erp-button>
                  <div style="clear: both; height: 0" />
                </div>
                <span
                    v-if="
                    isSearchSectionVisible &&
                    selectedData.length > 3
                  "
                >... 외 {{ selectedData.length - 3 }}건</span
                >
              </div>
              <div style="clear: both; height: 0" />
            </div>
          </div>
        </section>
        <!-- 아코디언 : accordion / 닫힘 : close -->
        <section
            :class="[
            'article-section',
            'section-02',
            'accordion',
            { open: isSearchSectionVisible },
          ]"
        >
          <div class="section-header">
            <div class="header-left">
              <div class="header-title" style="background: none; padding:0;" >
                회원 조건 정보
              </div>
              <div class="header-caption">
                [ {{ totalVisit | numberWithCommas }} 건 ]
              </div>
            </div>
            <div class="header-caption"></div>
          </div>
          <div class="section-body" style="border: none">
            <grid
                ref="couponVisitSearchGrid"
                id="couponVisitSearchGrid"
                v-bind="visitGridProps"
                @cellClick="couponVisitSearchGridCellClick"
                @filtered="onVisitGridDataFiltered"
                @sorted="onVisitGridDataFiltered"
                @paged="onVisitGridDataFiltered"
            />
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<style scoped>
.iconClose{display:block;float:left;width:11px;height:11px;border-radius:50%;background:#666 url(../../assets/images/common/multiselect-close.png) no-repeat center center}
.body-data.outerData + .body-data.outerData{margin-top:-1px}
.body-data.outerData .title.outerDataTitle{display:flex;align-items:center;border-top:1px solid #000}
.body-data.outerData .title.outerDataTitle .row{border-bottom:none;display:inline-block;line-height:1.5}
.body-data.outerData .title.outerDataTitle .item .check::before{display:none}
.body-data.outerData .title.outerDataTitle .outerDataTitleItem{width:100%;text-align:center}
.body-data.innerData{border-top:1px solid #000}
.body-data.innerData .data-content .field{width:calc((100% / 3) + 1px)}
.body-data.innerData .data-content .field .title{text-align:right}
.body-data.innerData .data-content .field .content.title ul.row{float:right}
.body-data.innerData .data-content .field .content.title li.item{padding-right:12px}
.body-data.innerData .data-content .field .content.title .item .check::before{display:none}
.body-data.innerData .data-content .field .content.title .item .check .label{color:#000}
body .appContent .article-section.section-01.accordion.close > .section-body{flex:1;border:1px solid #ccc;border-top:1px solid #ccc!important}
body .appContent .article-section.section-02.accordion .header-title{background-image:url(../../assets/images/common/accordion-bottom.png)}
body .appContent .article-section.section-02.accordion.close .header-title{background-image:url(../../assets/images/common/accordion-top.png)}
body .appContent .body-article .article-section.section-01.close{height:215px}
body .appContent .body-article .article-section.section-01.open{height:calc(100% - 46px)}
body .appContent .body-article .article-section.section-01:not(.close){height:75px}
body .appContent .body-article .article-section.section-01:not(.close) > .section-body{border-top:0;overflow:hidden}
body .appContent .body-article .article-section.section-01:not(.close) > .section-body button{display:none}
body .appContent .body-article .article-section.section-02{height:calc(100% - 215px)}
body .appContent .body-article .article-section.section-02.open{height:calc(100% - 75px)}
body .article-section.accordion.close > .section-header .header-caption,body .article-section.accordion.close > .section-header .header-text,body .article-section.accordion.close > .section-header .header-label,body .article-section.accordion.close > .section-header .header-check,body .article-section.accordion.close > .section-header .header-button,body .article-section.accordion.close > .section-header .header-switch{display:block}
</style>

<script>

import CheckBoxRow from "@/components/common/CheckBoxRow";
import InputNumber from "@/components/common/InputNumber";
import InputDateRange from "@/components/common/datetime/InputDateRange";
import InputTime from "@/components/common/datetime/InputTime";
import moment from "moment";
import { commonCodesGetCommonCode } from "@/utils/commonCodes";
import { visitSearchNameObj } from "@/utils/visitInitData";
import routeViewMixin from "@/views/layout/mixin/routeViewMixin";
import commonMixin from "@/views/layout/mixin/commonMixin";
import InputText from "@/components/common/text/InputText";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import { numberWithCommas } from "@/utils/number";
import {  mapGetters, mapActions } from "vuex";
import Grid from "@/components/grid/Grid";
import ErpButton from "@/components/button/ErpButton.vue";
import {
  FORMAT_TEL_CELLPHONE_NUMBER,
} from "@/components/grid/GridCellDataFormatUtil";
import GolfErpAPI from "@/api/v2/GolfErpAPI";
import { ExcelExport } from "@syncfusion/ej2-vue-grids";


moment.locale("ko");

const couponSearchInitOption = {
  visitInfo: {
    memberDiv: [],
    sexCode: [],
    ageCodes: [],
    hp4: null,
    visitDate: { from: null, to: null },
    visitStartTime: null,
    visitEndTime: null,
    bsnCode: [],
    dwCode: [],
    visitCnt: null,
  },
  // exclude: {
  //   members: [],
  // },
};

export default {
  name: "CouponCheckinSearch",
  mixins: [routeViewMixin, commonMixin, confirmDialogMixin],
  filters: {
    numberWithCommas,
  },
  components: {
    Grid,
    InputText,
    InputTime,
    InputDateRange,
    InputNumber,
    CheckBoxRow,
    ErpButton,
  },
  watch: {
    couponSearchOption: {
      deep: true,
      handler(data) {
        this.selectedData = [];
        Object.keys(data).forEach((key) => {
            Object.entries(data[key]).forEach(([innerKey, value]) => {
              visitSearchNameObj[key][innerKey].dataSet = value;
              const data = visitSearchNameObj[key][innerKey].value;
              if (data) {
                const selectedObj = {
                  name: visitSearchNameObj[key].title + ">" + visitSearchNameObj[key][innerKey].title,
                  key,
                  innerKey,
                  data,
                };
                this.selectedData.push(selectedObj);
              }
            });
        });
      },
    },
  },
  computed: {
    ...mapGetters(["username"]),
    ...mapGetters("documents", ["isCouponCheckinExcelDownloading"]),

    datetimeString() {
      return moment().format(`YYYY-MM-DD HH:mm:ss`);
    },
    visitGridProps() {
      let columns = [
        {
          name: "내장정보",
          columns: [
            {
              minWidth: 16,
              name: "회원명",
              width: 90,
              field: "memberName",
              type: String,
              cellStyle: {
                textAlign: "center",
              },
              // cellClass: () => [this.$t('className.grid.deleteHoverArea')],
            },
            {
              minWidth: 16,
              name: "연락처",
              width: 100,
              sortable: false,
              filterable: false,
              field: "memberPhoneNumber",
              type: String,
              format: FORMAT_TEL_CELLPHONE_NUMBER,
              cellStyle: {
                textAlign: "center",
              },
            },
            {
              minWidth: 16,
              name: "성별",
              width: 65,
              field: "memberGenderComName",
              type: String,
              cellStyle: {
                textAlign: "center",
              },
            },
            // {
            //   minWidth: 16,
            //   name: "요일",
            //   width: 60,
            //   field: "dwCodeComName",
            //   type: Number,
            //   cellStyle: {
            //     textAlign: "center",
            //   },
            // },
            {
              minWidth: 16,
              name: "내장횟수",
              width: 60,
              field: "visitWeekTotalCount",
              type: Number,
              cellStyle: {
                textAlign: "center",
              },
            },
            {
              minWidth: 16,
              name: "생년월일",
              width: 90,
              field: "memberBirthday",
              type: Date,
              cellStyle: {
                textAlign: "center",
              },
            },
            {
              minWidth: 16,
              name: "연령",
              width: 60,
              field: "memberAge",
              type: Number,
              cellStyle: {
                textAlign: "center",
              },
            },
            {
              minWidth: 16,
              name: "지역",
              width: 100,
              field: "memberDetailsAreaCodeComName",
              type: String,
              cellStyle: {
                textAlign: "center",
              },
            },
            {
              minWidth: 16,
              name: "집 주소1",
              width: 250,
              field: "memberDetailHomeAddr1",
              type: String,
            },
            {
              minWidth: 16,
              name: "집 주소2",
              width: 200,
              field: "memberDetailHomeAddr2",
              type: String,
            },
            {
              minWidth: 16,
              name: "회원구분",
              width: 90,
              field: "memberDivisionComName",
              type: String,
              cellStyle: {
                textAlign: "center",
              },
            },
          ],
        },
      ];

      return {
        columns,
        records: this.members,
        visibleRowNumberColumn: true,
        sortable: this.isSearched,
        filterable: this.isSearched,
        sizeOfRecordPerPage: 50,
        countOfAllRecords: this.totalVisit,
        rangeOfPages: 10,
        provides: [ExcelExport],
      };
    },
  },
  mounted() {
    this.searchInit();
  },
  data() {
    return {
      isLoading: false,
      isSearched: false,
      isSearchSectionVisible: false,
      totalVisit: 0,
      members: [],
      selectedData: [],
      vueCouponSearchNameObj: JSON.parse(JSON.stringify(visitSearchNameObj)),
      couponSearchOption: JSON.parse(JSON.stringify(couponSearchInitOption)),
    };
  },
  methods: {
    ...mapActions("documents", ["downloadExcelVisitor"]),
    handleSearchSectionHeaderClick() {
      this.isSearchSectionVisible = !this.isSearchSectionVisible;

    },
    searchInit() {
      this.couponSearchOption = JSON.parse(
          JSON.stringify(couponSearchInitOption)
      );
    },
    deleteSelectedData(key, innerKey) {
      this.couponSearchOption[key][innerKey] = JSON.parse(
          JSON.stringify(couponSearchInitOption[key][innerKey])
      );
    },
    onVisitGridDataFiltered(event) {
      if (!event) {
        return;
      }
      this.searchMembers();
    },
    onChangeVisitTime() {
      if (
          (!this.couponSearchOption.visitInfo.visitStartTime ||
              this.couponSearchOption.visitInfo.visitStartTime === "00:00") &&
          (!this.couponSearchOption.visitInfo.visitEndTime ||
              this.couponSearchOption.visitInfo.visitEndTime === "00:00")
      ) {
        this.couponSearchOption.visitInfo.visitStartTime = null;
        this.couponSearchOption.visitInfo.visitEndTime = null;
      }
    },
    async onSearchClick() {
      this.$refs["couponVisitSearchGrid"].resetPage();
      await this.searchMembers();

      if (
          this.$refs["couponVisitSearchGrid"].getSelectedRows().length < 1 && this.totalVisit
      ) {
        this.$refs["couponVisitSearchGrid"].selectRow(0);
      }
    },
    makeSearchOptions() {
      const limit = this.visitGridProps.sizeOfRecordPerPage;
      const { page, filters, orders } = this.$refs[
          "couponVisitSearchGrid"
          ].getOrdersAndFiltersAndPage();

      const _orders = JSON.parse(JSON.stringify(orders || []));
      // if (_orders.findIndex(({ field }) => field === "memberName") < 0) {
      //   _orders.push({
      //     field: "memberName",
      //     direction: "asc",
      //   });
      // }

      const genderList = this.couponSearchOption.visitInfo.sexCode;
      const gender = genderList.length === 1 ? genderList.join("") : undefined;


      const visitBsnCodeList = this.couponSearchOption.visitInfo.bsnCode;
      const visitBsnCode =
          visitBsnCodeList.length === 1 ? visitBsnCodeList.join("") : undefined;


      return {
        memberDivisions:
            this.couponSearchOption.visitInfo.memberDiv?.length > 0 &&
            this.couponSearchOption.visitInfo.memberDiv?.length !== commonCodesGetCommonCode("MEMBER_DIV")?.length ? this.couponSearchOption.visitInfo.memberDiv : undefined,
        gender,


        ageCodes:
            this.couponSearchOption.visitInfo.ageCodes?.length > 0 &&
            this.couponSearchOption.visitInfo.ageCodes?.length !==
            commonCodesGetCommonCode("AGE_DISTRB")?.length
                ? this.couponSearchOption.visitInfo.ageCodes
                : undefined,
        endOfHpNumber: this.couponSearchOption.visitInfo.hp4 || undefined,



        visitDateFrom:
            (this.couponSearchOption.visitInfo.visitDate.from) || undefined,
        visitDateTo:
            (this.couponSearchOption.visitInfo.visitDate.to) || undefined,
        visitTimeFrom:
            (this.couponSearchOption.visitInfo.visitStartTime) || undefined,
        visitTimeTo:
            (this.couponSearchOption.visitInfo.visitEndTime) || undefined,
        visitBsnCode: (visitBsnCode) || undefined,
        visitDayOfWeeks:
            (this.couponSearchOption.visitInfo.dwCode.length > 0 && this.couponSearchOption.visitInfo.dwCode?.length !== commonCodesGetCommonCode("DW_CODE")?.length
                    ? this.couponSearchOption.visitInfo.dwCode
                    : undefined
            ) || undefined,
        visitCount:
            (this.couponSearchOption.visitInfo.visitCnt) || undefined,
        limit,
        offset: (page - 1) * limit,
        filters: filters.length > 0 ? filters : undefined,
        orders: _orders.length > 0 ? _orders : undefined,
      };
    },
    async searchMembers() {
      if (
          (!this.couponSearchOption.visitInfo.visitDate.from ||
              !this.couponSearchOption.visitInfo.visitDate.to)
      ) {
        return this.errorToast(
            this.$t("main.validationMessage.requiredMessage", ["내장일자"])
        );
      }

      if (this.isLoading) {
        return this.errorToast("데이터를 불러오는 중입니다.");
      }

      this.isLoading = true;

      try {
        const searchOptions = this.makeSearchOptions();

        const result = await GolfErpAPI.fetchRecordsAndCountVisiter(
            searchOptions
        );

        this.totalVisit = result.total;
        this.members = result.records;
        this.isSearched = true;
      } catch (e) {
        console.error(e);
      }

      this.isLoading = false;
    },
    couponVisitSearchGridCellClick(event, payload) {
      const {
        column: {
          field,
        },
        record,
      } = payload;

      // if (field === "memberName") {
      //   const findIndex = this.couponSearchOption.exclude.members.findIndex(item => item.membershipId === record.id);
      //
      //   if (findIndex < 0) {
      //     this.couponSearchOption.exclude.members.push({
      //       membershipId: record.id,
      //       memberName: record.memberName,
      //     });
      //
      //     this.onSearchClick();
      //   }
      // }
    },
    async onExcelButtonClicked() {
      if (50000 < this.totalVisit) {
        this.errorToast("데이터가 너무 많습니다. 5만건 이하로 시도해주세요.");
        return;
      }

      if (
        (!this.couponSearchOption.visitInfo.visitDate.from ||
          !this.couponSearchOption.visitInfo.visitDate.to)
      ) {
        return this.errorToast(
          this.$t("main.validationMessage.requiredMessage", ["내장일자"])
        );
      }

      const { filters, orders } = this.$refs[
        "couponVisitSearchGrid"
      ].getOrdersAndFiltersAndPage();
      const columns = this.$refs["couponVisitSearchGrid"].getColumns();

      // const _orders = JSON.parse(JSON.stringify(orders || []));
      // if (_orders.findIndex(({ field }) => field === "memberName") < 0) {
      //   _orders.push({
      //     field: "memberName",
      //     direction: "asc",
      //   });
      // }

      const genderList = this.couponSearchOption.visitInfo.sexCode;
      const gender = genderList.length === 1 ? genderList.join("") : undefined;

      const visitBsnCodeList = this.couponSearchOption.visitInfo.bsnCode;
      const visitBsnCode =
        visitBsnCodeList.length === 1 ? visitBsnCodeList.join("") : undefined;

      this.downloadExcelVisitor({
        payload: {
          memberDivisions:
            this.couponSearchOption.visitInfo.memberDiv?.length > 0 &&
            this.couponSearchOption.visitInfo.memberDiv?.length !==
              commonCodesGetCommonCode("MEMBER_DIV")?.length
              ? this.couponSearchOption.visitInfo.memberDiv
              : undefined,
          gender,
          ageCodes:
            this.couponSearchOption.visitInfo.ageCodes?.length > 0 &&
            this.couponSearchOption.visitInfo.ageCodes?.length !==
              commonCodesGetCommonCode("AGE_DISTRB")?.length
              ? this.couponSearchOption.visitInfo.ageCodes
              : undefined,
          endOfHpNumber: this.couponSearchOption.visitInfo.hp4 || undefined,
          visitDateFrom:
            this.couponSearchOption.visitInfo.visitDate.from || undefined,
          visitDateTo:
            this.couponSearchOption.visitInfo.visitDate.to || undefined,
          visitTimeFrom:
            this.couponSearchOption.visitInfo.visitStartTime || undefined,
          visitTimeTo:
            this.couponSearchOption.visitInfo.visitEndTime || undefined,
          visitBsnCode: visitBsnCode || undefined,
          visitDayOfWeeks:
            this.couponSearchOption.visitInfo.dwCode.length > 0 &&
            this.couponSearchOption.visitInfo.dwCode?.length !==
              commonCodesGetCommonCode("DW_CODE")?.length
              ? this.couponSearchOption.visitInfo.dwCode
              : undefined,
          visitCount:
            this.couponSearchOption.visitInfo.visitCnt || undefined,
          filters: filters.length > 0 ? filters : undefined,
          // orders: _orders.length > 0 ? _orders : undefined,
          orders: undefined,
          columns,
        },
      });
    },
  },
};
</script>
